import { PatientActions } from "src/redux/actions/constant";

const {
    GET_PAYER_PLAN_TYPE_SUCCESS,
GET_PAYER_PLAN_TYPE_FAILURE
} = PatientActions;

const intialEnterprisePayerPlanState: object = {
  isError: false,
  enterprisePayerPlanType: null,
};
export const getPayerPlanTypeReducer = (
  state = intialEnterprisePayerPlanState,
  action: any
) => {
  switch (action.type) {
    case GET_PAYER_PLAN_TYPE_SUCCESS: {
      return {
        ...state,
        isError: false,
        enterprisePayerPlanType: action.payload,
      };
    }

    case GET_PAYER_PLAN_TYPE_FAILURE:
      return {
        ...state,
        isError: true,
        enterprisePayerPlanType: action.payload,
      };


    default:
      return state;
  }
};
